import { memo } from "react";
import FeatureUnavailable from "ui/components/Availability/FeatureUnavailable/FeatureUnavailable";
import { ZPosition } from "ui/components/Modal/types";
import { Button } from "ui/components/Button/Button";
import { FleetUnavailableProps } from "./types";

const FleetUnavailable: React.FC<FleetUnavailableProps> = ({ show, onAddVehicle, onImport }) => {
  return (
    <FeatureUnavailable
      show={show}
      zPosition={ZPosition.Bottom}
      title="Dodajte prvo vozilo"
      description="Za početak rada unesite prvo vozilo ili uvezite vozila iz datoteke."
      actions={
        <div className="flex gap-2">
          <Button variant="primary" startIcon="/media/icons/plus.svg" onClick={onImport}>
            Uvezi vozila
          </Button>
          <Button variant="secondary" startIcon="/media/icons/plus.svg" onClick={onAddVehicle}>
            Dodaj vozilo
          </Button>

        </div>
      }
    />
  );
};

export default memo(FleetUnavailable);
